import { SiteDirection } from '@wix/a11y-adapters';
import { RTL_LANGUAGES } from '../constants';
export const getIsLanguageDirectionMatchingDomDirection = _ref => {
  let {
    siteDomDirection,
    siteLanguage
  } = _ref;
  if (!siteDomDirection || siteLanguage === '') {
    return true;
  }
  const languageDirection = RTL_LANGUAGES.includes(siteLanguage) ? SiteDirection.RTL : SiteDirection.LTR;
  return siteDomDirection === languageDirection;
};
//# sourceMappingURL=get-is-language-direction-matching-dom-direction.js.map